<div class="row">
    <div class="col-md-12">
        <app-page-title [title]="'Shopping Cart'"></app-page-title>
        <div *ngIf="cartIsReady && shoppingCartItemCount$ | async; else emptyShoppingCart">
            <p>You have {{ shoppingCartItemCount$ | async }} item(s) in your cart:</p>
            <p>
                <a
                    routerLink="/product-shopping"
                    class="btn btn-primary btn-sm m-2"
                >Continue Shopping</a>
                <a
                    (click)="checkoutRedirect()"
                    class="btn btn-primary btn-sm m-2"
                >Checkout</a>
            </p>
            <app-cart-items
                [shoppingCart]="(shoppingCart$ | async)"
                (removeItem)="removeFromCart($event)"
            ></app-cart-items>
            <div>
                <a
                    routerLink="/product-shopping"
                    class="btn btn-primary btn-sm m-2"
                >Continue Shopping</a>
                <a
                    (click)="checkoutRedirect()"
                    class="btn btn-primary btn-sm m-2"
                >Checkout</a>
                <br>
                <br>
                <p>You have almost completed your purchase! Please click 'Checkout' to finish your purchase.</p>
            </div>
        </div>
        <ng-template #emptyShoppingCart>
            <p>Your shopping cart is empty.</p>
            <a
                routerLink="/product-shopping"
                class="btn btn-primary"
            >Continue Shopping</a>
        </ng-template>
    </div>
</div>
